<template>
  <div>

    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="Yetki" class="float-right">
        <el-button type="info" size="small" class="YeniBtn" @click="this.YeniBtn">{{ Sayfa.ButtonAdi }}
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="SpotlightKutu">
        <div class="input">
          <el-input
            :disabled="lo"
            placeholder="Bina Adı ile arama yapın, tamamı için boş bırakın (ENTER'A BASIN)"
            v-model="Kelime"
            @keyup.enter.native="Getir">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <el-table
        v-if="Liste"
        :data="Liste.filter(data => !search || data.Adi.toLowerCase().includes(search.toLowerCase()))"
        class="golgetable"
        :height="Height">
        <el-table-column
          label="No"
          prop="BinaNo"
          width="100">
        </el-table-column>
        <el-table-column
          label="Adı"
          prop="TextAdi">
        </el-table-column>
        <el-table-column
          :label="Daire"
          prop="Say">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Sayfa.Arama"/>
          </template>
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip v-if="Yetki" class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2  tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="Sayfa.EkranAdi"
                          placement="top-start">
                <i
                  class="feather-airplay tableibtn text-success"
                  @click="$router.push('/yonetim/'+Mod+'/'+scope.row.id)">
                </i>

              </el-tooltip>
              <el-tooltip v-if="scope.row.Silinebilir && Yetki" class="item" effect="dark"
                          :content="Sayfa.SilAdi"
                          placement="top-start">
                <i
                  class="feather-trash tableibtn text-danger"
                  @click="SilOnay(scope.row.id)">
                </i>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <div class="ekranbos" v-if="!Liste"></div>
    </div>
    <BinaFormModal :data="FormData" :ModalOlayi="ModalOlayi" :Baslik="Baslik"
                   @ModalOlayi="SayfaYukle"></BinaFormModal>
  </div>
</template>

<script>
import BinaFormModal from '../../../components/Pack/Yonetim/bina/FormModal'
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, BinaFormModal},
  data() {
    return {
      Kelime: null,
      Daire: null,
      Yetki: false,
      ModalOlayi: false,
      Baslik: null,
      lo: false,
      Height: window.innerHeight - 170,
      Site: 0,
      Sayfa: {
        ButtonAdi: 'Bina Ekle',
        DuzenleAdi: 'Düzenle',
        SilAdi: this.$t('eGenel.11'),
        Button: null,
        EkranAdi: 'Ekran',
        Adi: 'Bina Listesi',
        Menu: [],
        MenuDisplay: null,
      },
      Liste: null,
      FormData: {
        Ortak: false,
        Durum: true,
        Online: true,
        oOdeme: true,
        Gecikme: true,
        Tolerans: 0,
        iGun: 90,
        mZam: 0,
        Site: 0,
        id: null,
        SGK: {
          SicilNo: "",
          Sube: "",
          Kullanici: "",
          Sifre: "",
          iSifre: ""
        },
        Temsilci: {
          AdSoyad: "",
          Unvan: "",
          Email: "",
          Telefon: "",
          Dahili: ""
        },
      },
      search: '',
      Mod: null
    }
  },
  methods: {
    SayfaYukle() {
      this.ModalOlayi = false;
      this.lo = false
    },
    Getir() {
      this.ModalOlayi = false;
      this.lo = true;
      this.$store.dispatch("Get", {path: 'yonetim/' + this.Mod + '/arama/' + this.Kelime})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

      this.Mod = this.$route.path == '/yonetim/bina' ? 'bina' : 'site'
      this.Site = this.$route.path == '/yonetim/bina' ? 0 : 1
      if (this.$route.path == '/yonetim/bina') this.Sayfa.Adi = 'Bina Listesi'; else this.Sayfa.Adi = 'Site Listesi'
      if (this.$route.path == '/yonetim/bina') this.Sayfa.ButtonAdi = 'Bina Ekle'; else this.Sayfa.ButtonAdi = 'Site Ekle'
    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/bina/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    YeniBtn() {
      this.ModalOlayi = true;
      this.Baslik = this.Sayfa.ButtonAdi;
      this.FormData = {
        Ortak: false,
        Durum: true,
        Online: true,
        oOdeme: true,
        Gecikme: true,
        Tolerans: 0,
        kLimit: 0,
        kKomisyon: 0,
        iGun: 90,
        mZam: 0,
        id: null,
        Site: this.Site,
        SGK: {
          SicilNo: null,
          Sube: null,
          Kullanici: null,
          Sifre: null,
          iSifre: null
        },
        Temsilci: {
          AdSoyad: null,
          Unvan: null,
          Email: null,
          Telefon: null,
          Dahili: null
        },
      }
    },
    DuzenleBtn(Veri) {

      // console.log(Veri)

      this.FormData = Veri;
      this.Baslik = Veri.Adi + ' Düzenle';
      this.ModalOlayi = true
    },
  },
  created() {
    this.Mod = this.$route.path == '/yonetim/bina' ? 'bina' : 'site'
    this.$store.commit("SayfaBilgi", this.Sayfa);
    this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
    this.SayfaYukle();
    this.Daire = this.$route.path == '/yonetim/bina' ? 'Mesken Sayısı' : 'Bina Sayısı'

  },
  watch: {
    '$route.path': function (id) {
      this.lo = true;
      this.Liste = []
      this.Mod = this.$route.path == '/yonetim/bina' ? 'bina' : 'site'
      this.Daire = this.$route.path == '/yonetim/bina' ? 'Mesken Sayısı' : 'Bina Sayısı'
      this.Site = this.$route.path == '/yonetim/bina' ? 0 : 1
      if (this.$route.path == '/yonetim/bina') this.Sayfa.Adi = 'Bina Listesi'; else this.Sayfa.Adi = 'Site Listesi'
      if (this.$route.path == '/yonetim/bina') this.Sayfa.ButtonAdi = 'Bina Ekle'; else this.Sayfa.ButtonAdi = 'Site Ekle'
      this.SayfaYukle()
    }
  }
}
</script>
<style scoped>
.SpotlightKutu {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/pages/Yonetim/bina/Liste.vue